var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page",attrs:{"id":"app"}},[(_vm.$route.meta.showHeader)?_c('HeaderPage'):_vm._e(),_c('router-view'),(_vm.$route.meta.showFooter)?_c('FooterPage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }